import { getUserAccess, selectedLoggedInUsersAccesses } from 'Deer/helpers/getUserAccess';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import { selectUserRoles } from 'selectors/userRoles';
import store from 'store.js';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import {
  PLATFORM_ADMIN,
  ENGAGEMENT_ADMIN,
  FEEDBACK_ADMIN,
  GOAL_ADMIN,
  ONE_ON_ONE_ADMIN,
  REVIEW_ADMIN,
  TASK_ADMIN,
  USER_ROLES,
  CUSTOM_ADMIN,
  DISCIPLINARY_ADMIN,
} from 'constants/ProjectConstants';

export const checkRoleAccess = (roleKey, enabledFeatures) => {
  const ROLE_KEYS = USER_ROLES({
    enabledFeatures,
  }).map((role) => role.value);
  if (!ROLE_KEYS.includes(roleKey)) {
    console.error(`Role named '${roleKey}' is not a valid role. Not found in FEATURE_KEYS`);
    return false;
  }
  const userRoles = checkNewNavEnabled()
    ? selectedLoggedInUsersAccesses(store.getState()).adminAccesses
    : selectUserRoles(store.getState());
  return userRoles.includes(roleKey);
};

export const checkUserIsGoalAdmin = () => {
  const userRoles = selectUserRoles(store.getState());
  return checkNewNavEnabled() ? getUserAccess().isGoalAdmin : userRoles.includes(GOAL_ADMIN);
};

export const checkUserIsReviewAdmin = () => {
  const userRoles = selectUserRoles(store.getState());
  return checkNewNavEnabled() ? getUserAccess().isReviewAdmin : userRoles.includes(REVIEW_ADMIN);
};

export const checkUserIsCustomReviewAdmin = () => {
  const userRoles = selectUserRoles(store.getState());
  return checkNewNavEnabled() ? getUserAccess().isCustomReviewAdmin : userRoles.includes(CUSTOM_ADMIN);
};

export const checkUserIsFeedbackAdmin = () => {
  const userRoles = selectUserRoles(store.getState());
  return checkNewNavEnabled() ? getUserAccess().isFeedbackAdmin : userRoles.includes(FEEDBACK_ADMIN);
};

export const checkUserIsEngagementAdmin = () => {
  const userRoles = selectUserRoles(store.getState());
  return checkNewNavEnabled() ? getUserAccess().isEngagementAdmin : userRoles.includes(ENGAGEMENT_ADMIN);
};

export const checkUserIsDisciplinaryActionsAdmin = () => {
  const userRoles = selectUserRoles(store.getState());
  return checkNewNavEnabled() ? getUserAccess().isDisciplinaryActionsAdmin : userRoles.includes(DISCIPLINARY_ADMIN);
};
export const checkUserIsOneOnOneAdmin = () => {
  const userRoles = selectUserRoles(store.getState());
  return checkNewNavEnabled() ? getUserAccess().isOneOnOneAdmin : userRoles.includes(ONE_ON_ONE_ADMIN);
};

export const checkUserIsTaskAdmin = () => {
  const userRoles = selectUserRoles(store.getState());
  return userRoles.includes(TASK_ADMIN);
};

export const checkUserIsPlatformAdmin = () => {
  const userRoles = selectUserRoles(store.getState());
  return checkNewNavEnabled() ? getUserAccess().isPlatformAdmin : userRoles.includes(PLATFORM_ADMIN);
};

export const checkUserIsIndividualContributor = () => {
  const userRoles = selectUserRoles(store.getState());
  const checkIfUserIsManager = store.getState()?.loggedInEmployee?.data?.isHRISManager;
  return userRoles.filter((role) => role !== CUSTOM_ADMIN).length === 0 && !checkIfUserIsManager;
};

export const checkUserIsAnyModuleAdmin = () => {
  const empData = selectLoggedInEmployeeData(store.getState());

  const ROLE_KEYS = USER_ROLES({
    enabledFeatures: empData?.enabledFeatures ?? [],
  }).map((role) => role.value);
  const userRoles = selectUserRoles(store.getState());
  return ROLE_KEYS.some((role) => userRoles.includes(role));
};

export const checkUserIsHRISManager = () => {
  const empData = selectLoggedInEmployeeData(store.getState());
  return empData?.isHRISManager;
};

export const checkUserIsSuperAdmin = () => {
  const empData = selectLoggedInEmployeeData(store.getState());
  return empData?.isSuperAdmin();
};

export const checkUserIsSelf = (empId) => {
  const empData = selectLoggedInEmployeeData(store.getState());
  if (empData.id !== empId) return false;
  return true;
};
